import graphql__39abe5e1a5d112314e86 from "./__generated__/CreateEmailTemplateDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Checkbox from "../form/Checkbox";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateEmailTemplateDialogMutation} from "./__generated__/CreateEmailTemplateDialogMutation.graphql";
import {useNavigate} from "react-router-dom";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    handleCloseDialog: () => void
}

const CreateEmailTemplateDialog: React.FC<Props> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateEmailTemplateDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__39abe5e1a5d112314e86,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                    navigate('/marketing/templates/' + response.createEmailTemplate?.id)
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateEmailTemplate'})
            }
        )
    }

    const initialValues = {
        name: '',
        primaryLanguage: intl.locale.split('-')[0] || 'de',
        reusable: false
    }

    const validationSchema = yup.object().shape({
        name: yup.string()
            .min(2, intl.formatMessage({id: 'validation.field.nameTooShort'}))
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
        reusable: yup.boolean()
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.nameLabel'})}</Label>
                    <Field name="name" type="text" autoFocus={true} placeholder={intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.namePlaceholder'})} data-1p-ignore="true"/>
                </Row>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.reusableLabel'})}</Label>
                    <div>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <Checkbox name="reusable"/>
                            <span className="text-sm text-gray-700">{intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.reusableCheckboxLabel'})}</span>
                        </label>
                        <p className="text-xs text-gray-500 mt-1">{intl.formatMessage({id: 'dialog.CreateEmailTemplateDialog.reusableHelp'})}</p>
                    </div>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateEmailTemplateDialog;
